import React from 'react';
import { HelpText } from '../Card';
import { CONTACT_PHONE } from '../../../constants/business';

// The contact line under each booking and payment step.
const ContactHelpText = ({ phone = CONTACT_PHONE }) => (
  <HelpText>
    For further information please press the chat icon or call <b>{phone}</b> to
    speak with us.
  </HelpText>
);

export default ContactHelpText;
